import { MenuItem } from "./interface";

const menuAdministrador: MenuItem[] = [
    {
        nome: "Início",
        url: "/home"
    },
    {
        nome: "Exportação",
        url: "/exportacao"
    },
];

export default menuAdministrador;
